import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=20a2dfd7&"
import script from "./Example.ts?vue&type=script&lang=ts&"
export * from "./Example.ts?vue&type=script&lang=ts&"
import style0 from "./Example.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports